import React from 'react'
import { renderSortingIcon } from './functions'

const FormRowHeaderCell = ({ sorting, sort, title, width, filter, collapsibleHeader}) => {
        //used to be column-container
        return <li id="header-cell-container" style={{ width }}> 
            <h3 id="cell-header" 
                className={`flex-centered FontSize18`} 
                onClick={sort}>
                        {title ? <p className={`${collapsibleHeader ? "small-screen-removable" : ""}`}>{title}</p> : null}
                        {sort ? renderSortingIcon(sorting) : null}
                        {filter ? filter : null}
                    </h3> 
                </li>
}

export default FormRowHeaderCell